<div class="dark-blue">
  <nestas-toolbar [steps]="steps"></nestas-toolbar>
</div>
<div class="wrap template-component">

  <div *ngIf="!templates.length">
    <mat-spinner *ngIf="!templates.length" style="margin-left:30px;"></mat-spinner>
  </div>

  <nestas-searchbar (search)="filterTemplates($event)" [placeholder]="translate.instant('TEMPLATE.SEARCH_TEMPLATES')" class="flexbox wrap-search"></nestas-searchbar>

  <mat-card *ngIf="templates.length">
    <mat-card-title>{{translate.instant('TEMPLATE.TEMPLATES')}}</mat-card-title>
    <div>
      {{translate.instant('TEMPLATE.TEMPLATES_HELP')}} 
    </div>
    <br />
    <mat-slide-toggle [(ngModel)]="showMineOnly" color="primary">{{translate.instant('TEMPLATE.SHOW_ONLY_MINE')}}
    </mat-slide-toggle>

    <table class="default-table tight" [formGroup]="form">
      <tr>
        <th *ngIf="pid"><mat-checkbox formControlName="allSelected" (click)="selectAll()"></mat-checkbox></th>
        <th style="width:225px;">{{translate.instant('DATA.NAME')}}</th>
        <th>{{translate.instant('DATA.TYPE')}}</th>
        <th>{{translate.instant('DATA.DESCRIPTION')}}</th>
        <th style="width:100px;">{{translate.instant('DATA.ROOM')}}</th>
        <th *ngIf="!pid"><i class="material-icons ic-icon">account_circle</i></th>
        <th *ngIf="!pid">&nbsp;</th>
      </tr>
      <ng-container formArrayName="items" *ngFor="let ft of templates; index as i">

        <tr *ngIf="!ft.deleted && !ft.hidden && !hideCompanyTemplates(ft) && !hideUsedTemplates(ft)" [formGroupName]="i">
          <td *ngIf="pid">
            <mat-checkbox formControlName="selection"></mat-checkbox>
          </td>

          <td>
            <mat-form-field class="fill">
              <mat-label></mat-label>
              <input matInput [readonly]="pid" type="text" placeholder="{{translate.instant('DATA.NAME')}}"
                (change)="nameChanged($event, i)" class="full-width margin-right-md" formControlName="name">
            </mat-form-field>
          </td>

          <td>
            <mat-form-field class="fill">
              <mat-label></mat-label>
              <!--<input matInput [readonly]="pid" type="text" placeholder="{{translate.instant('DATA.TYPE')}}"
                class="full-width margin-right-md" formControlName="type">-->

                <input matInput [readonly]="pid" type="text" (change)="valueChanged(i)" [matAutocomplete]="typeAutocomplete"
                placeholder="{{translate.instant('DATA.TYPE')}}" class="full-width margin-right-md"
                formControlName="type">
              <mat-autocomplete #typeAutocomplete="matAutocomplete">
                <mat-option *ngFor="let t of filteredTypes[i] | async" [value]="t">
                  {{ t }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </td>

          <td>
            <mat-form-field class="fill">

              <mat-label></mat-label>
              <input matInput [readonly]="pid" type="text" (change)="valueChanged(i)" placeholder="{{translate.instant('DATA.DESCRIPTION')}}"
                class="full-width margin-right-md" formControlName="description">
            </mat-form-field>
          </td>

          <td>
            <mat-form-field class="fill">
              <mat-label></mat-label>
              <input matInput [readonly]="pid" type="text" (change)="valueChanged(i)" [matAutocomplete]="roomAutocomplete"
                placeholder="{{translate.instant('DATA.ROOM')}}" class="full-width margin-right-md"
                formControlName="room">
              <mat-autocomplete #roomAutocomplete="matAutocomplete">
                <mat-option *ngFor="let c of filteredRooms[i] | async" [value]="c">
                  {{ c }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </td>

          <td *ngIf="!pid">
            <mat-checkbox formControlName="hasContractor"></mat-checkbox>
          </td>

          <td *ngIf="!pid"><i class="material-icons cursor" (click)="removeTemplate(i)">delete</i></td>
        </tr>

        <tr [formGroupName]="i" *ngIf="!ft.deleted && !ft.hidden && items.at(i).get('hasContractor').value && !hideCompanyTemplates(ft) && !hideUsedTemplates(ft)">
          <td *ngIf="pid"></td>
          <td colspan="2">
            <mat-form-field class="fill">
              <mat-label></mat-label>
              <input matInput [readonly]="pid" type="text" (change)="valueChanged(i)" [matAutocomplete]="contractorAutocomplete"
                placeholder="{{translate.instant('DATA.CONTRACTOR')}}" class="full-width margin-right-md"
                formControlName="contractor">
              <mat-autocomplete #contractorAutocomplete="matAutocomplete">
                <mat-option *ngFor="let c of filteredContractors[i] | async" [value]="formatContractor(c)">
                  {{formatContractor(c)}}
                </mat-option>
              </mat-autocomplete>

            </mat-form-field>
          </td>
        </tr>

      </ng-container>
    </table>
    <mat-card-actions class="clear-margin save-button" [ngStyle]="{'justify-content': (pid) ? 'flex-start' : 'flex-end', 'display': (pid) ? 'flex' : 'flex' }">
      <!--<button mat-raised-button color="primary" (click)="addContractor()">
        {{translate.instant('BUTTON.ACTION.ADD', {'data': 'Lijn'})}}
      </button>-->
      <button *ngIf="pid" mat-stroked-button (click)="cancel()">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>

      <button *ngIf="pid" class="add" mat-raised-button color="primary" (click)="addToPid()">
        {{translate.instant('TEMPLATE.COPY_TEMPLATES')}}
      </button>

      <button *ngIf="!pid" mat-raised-button color="primary" (click)="saveTemplates()">
        {{translate.instant('BUTTON.ACTION.SAVE')}}
      </button>

    </mat-card-actions>
  </mat-card>



</div>